import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import en from '../../../assets/i18n/en.json';

/** Traducciones en el bundle: sin HTTP extra ni menú vacío al primer paint. */
export function preloadTranslations(translate: TranslateService): () => Promise<unknown> {
  return () => {
    translate.setTranslation('en', en);
    translate.setDefaultLang('en');
    translate.addLangs(['en', 'fr']);
    return firstValueFrom(translate.use('en'));
  };
}
